import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import extend from 'lodash/extend';
import Ad from '../../../components/ad/ad';
import NotFound from '../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';
import Slug from '../../../components/slug/slug';
import Card from '../../../components/card/card';
import AllFeed from '../../../components/all_feed/all_feed';
import Advertorial, {
  isAdvertorial
} from '../../../components/advertorial/advertorial';
import { tagAllFeedAllStoriesRendered } from '../../../../redux/action_creators/tag/tag_all_feed_action_creators';
import formatPostObject from '../../../../utils/format_post_object';
import { imageSizesLookup } from '../../../../utils/cloudinary_asset_util';

// eslint-disable-next-line react/prefer-stateless-function
class Tag extends Component {
  render() {
    const { config, tagPage, tagFeaturedFeed, tagAllFeed } = this.props;

    if (tagPage.error || tagFeaturedFeed.error) {
      return (
        <section className="tag-page">
          <article className="tag-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (tagPage.isLoading) {
      return (
        <section className="tag-page">
          <article className="tag-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    const adData = get(tagPage, 'ads');
    const combinedAdModel = extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') },
      { definitions: get(adData, 'config.definitions') },
      { model: get(adData, 'model') }
    );

    const pgName = get(tagFeaturedFeed, 'tag.name');
    const pgDesc = get(tagFeaturedFeed, 'tag.description');
    const tags = get(tagAllFeed, 'posts[0].tags');
    const advertorial = isAdvertorial(tags);
    const imgSize = imageSizesLookup[1];
    const stories = get(tagAllFeed, 'posts') || [];

    return (
      <section
        className={`tag-page tag-page--custom ${
          advertorial ? 'tag-page--advertorial' : ''
        }`}
      >
        {advertorial ? (
          <Advertorial
            modifier="tag-page"
            tags={tags}
            adModel={combinedAdModel}
          />
        ) : (
          ''
        )}

        {advertorial ? (
          <div>
            <Slug slugName={pgName} className="tag-page" advertorial />
            <h3 className="page-description">{pgDesc}</h3>
            <Card
              config={config}
              type="featured"
              metadata={formatPostObject({
                props: this.props,
                post: get(stories, '[0]'),
                imgSize
              })}
              fullPageAdvertorial={advertorial}
            />
            {get(tagFeaturedFeed, 'top.length') ? (
              <div className="tag-page__video-ad-container">
                <Ad {...combinedAdModel} name="flexiblebillboard_1" />
                <Ad {...combinedAdModel} name="mobilerectangle_1" />
              </div>
            ) : (
              ''
            )}
            <AllFeed
              adModel={combinedAdModel}
              modifier="advertorial"
              stories={(stories || []).slice(1)}
              allRendered={get(tagAllFeed, 'allRendered')}
              updateAction={tagAllFeedAllStoriesRendered}
              config={config}
            />
            <div className="tag-page__ff-ad-container">
              <Ad {...combinedAdModel} name="flexiblebillboard_2" />
            </div>
          </div>
        ) : (
          <div>
            <AllFeed
              adModel={combinedAdModel}
              stories={get(tagAllFeed, 'posts')}
              allRendered={get(tagAllFeed, 'allRendered')}
              updateAction={tagAllFeedAllStoriesRendered}
              config={config}
            />
            <div className="tag-page__ff-ad-container">
              <Ad {...combinedAdModel} name="flexiblebillboard_2" />
              <Ad {...combinedAdModel} name="mobilerectangle_2" />
            </div>
          </div>
        )}
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    config: state.config || {},
    status: state.status.code,
    currentSite: state.config.site,
    tagFeaturedFeed: {
      featured: get(state, 'tagFeaturedFeed.featured') || [],
      top: get(state, 'tagFeaturedFeed.top') || [],
      tag: get(state, 'tagFeaturedFeed.tag') || {},
      source: get(state, 'tagFeaturedFeed.source') || '',
      error: get(state, 'tagFeaturedFeed.error') || false
    },
    tagPage: get(state, 'tagPage') || { error: true },
    tagScrollingModule: get(state, 'tagScrollingModule.data.posts') || [],
    tagAllFeed: {
      totalPosts: get(state, 'tagAllFeed.data.totalPosts', 0),
      totalPages: get(state, 'tagAllFeed.data.totalPages', 0),
      allRendered: get(state, 'tagAllFeed.data.allRendered', false),
      posts: get(state, 'tagAllFeed.data.posts', [])
    }
    // scrollingModule: get(state, 'scrollingModule.data.posts') || []
  };
}

Tag.propTypes = {
  config: PropTypes.shape({}).isRequired,
  tagPage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }).isRequired,
  tagFeaturedFeed: PropTypes.shape({
    featured: PropTypes.arrayOf(PropTypes.shape({})),
    top: PropTypes.arrayOf(PropTypes.shape({})),
    tag: PropTypes.object,
    source: PropTypes.string,
    error: PropTypes.bool
  }).isRequired,
  tagAllFeed: PropTypes.shape({
    posts: PropTypes.arrayOf(PropTypes.shape({})),
    allRendered: PropTypes.bool,
    totalPages: PropTypes.number,
    totalPosts: PropTypes.number
  }).isRequired
};

export default connect(mapStateToProps)(Tag);



// WEBPACK FOOTER //
// ./src/views/containers/pages/tag_page/sponsored_tag_page_custom.js